export const INSIGHTS_METRICS_LIMIT = 20;
